import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Select } from '../ui/select';
import { HoursUtilizationDashboardDark } from './HoursUtilizationDashboardDark';

interface HoursBankTabProps {
  projectId: string;
}

export const HoursBankTab: React.FC<HoursBankTabProps> = ({ projectId }) => {
  const [currentDate, setCurrentDate] = useState(() => {
    const now = new Date();
    return {
      month: now.getMonth() + 1,
      year: now.getFullYear()
    };
  });

  const months = [
    { value: 1, label: 'Janeiro' },
    { value: 2, label: 'Fevereiro' },
    { value: 3, label: 'Março' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Maio' },
    { value: 6, label: 'Junho' },
    { value: 7, label: 'Julho' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Setembro' },
    { value: 10, label: 'Outubro' },
    { value: 11, label: 'Novembro' },
    { value: 12, label: 'Dezembro' }
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);

  // Options for Select components
  const monthOptions = months.map(month => ({
    value: month.value.toString(),
    label: month.label
  }));

  const yearOptions = years.map(year => ({
    value: year.toString(),
    label: year.toString()
  }));

  const handlePreviousMonth = () => {
    setCurrentDate(prev => {
      if (prev.month === 1) {
        return { month: 12, year: prev.year - 1 };
      }
      return { month: prev.month - 1, year: prev.year };
    });
  };

  const handleNextMonth = () => {
    setCurrentDate(prev => {
      if (prev.month === 12) {
        return { month: 1, year: prev.year + 1 };
      }
      return { month: prev.month + 1, year: prev.year };
    });
  };

  const handleMonthChange = (month: number) => {
    setCurrentDate(prev => ({ ...prev, month }));
  };

  const handleYearChange = (year: number) => {
    setCurrentDate(prev => ({ ...prev, year }));
  };

  const selectedMonth = months.find(m => m.value === currentDate.month);

  return (
    <div className="space-y-6">
      {/* Month/Year Selector */}
      <Card variant="glass">
        <CardContent className="p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Calendar className="w-5 h-5 text-blue-400" />
              <h3 className="text-lg font-heading text-foreground-primary">
                Período de Consulta
              </h3>
            </div>
            
            <div className="flex items-center gap-3">
              {/* Navigation Buttons */}
              <Button
                variant="ghost"
                size="sm"
                onClick={handlePreviousMonth}
                className="h-8 w-8 p-0"
              >
                <ChevronLeft className="w-4 h-4" />
              </Button>

              {/* Month and Year Selectors */}
              <div className="flex items-center gap-2">
                <Select
                  value={currentDate.month.toString()}
                  onChange={(value) => handleMonthChange(Number(value))}
                  options={monthOptions}
                  className="min-w-[120px]"
                />

                <Select
                  value={currentDate.year.toString()}
                  onChange={(value) => handleYearChange(Number(value))}
                  options={yearOptions}
                  className="min-w-[80px]"
                />
              </div>

              <Button
                variant="ghost"
                size="sm"
                onClick={handleNextMonth}
                className="h-8 w-8 p-0"
              >
                <ChevronRight className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Hours Utilization Dashboard - Dark Version */}
      <HoursUtilizationDashboardDark
        projectId={projectId}
        billingMonth={currentDate.month}
        billingYear={currentDate.year}
        className="mt-6"
      />
    </div>
  );
};